import { dataLayer } from '@weatherbug/common';
import type { pollutantList } from '../constants';

const { AirQualityProvider } = dataLayer.providers;

export const AqiHealthAdviceAndTopTriggersType = {
    topTriggers: 'topTriggers',
    healthAdvice: 'healthAdvice'
} as const;

export enum PollutantType {
    pm25 = 'pm25',
    pm10 = 'pm10',
    o3 = 'o3',
    co = 'co',
    no2 = 'no2',
    so2 = 'so2'
}

export enum TopTriggerUnits {
    MicrogramsPerCubicMetres = 'μg/m\u00B3',
    PartsPerBillion = 'ppb'
}

interface PollutantNameUnit {
    formula: keyof typeof PollutantType;
    unit: TopTriggerUnits;
    formulaSubscript?: string;
    unitSuperscript?: string;
}

export const pollutantNameUnits: Record<keyof typeof PollutantType, PollutantNameUnit> = {
    pm25: {
        formula: PollutantType.pm25,
        unit: TopTriggerUnits.MicrogramsPerCubicMetres
    },
    pm10: {
        formula: PollutantType.pm10,
        unit: TopTriggerUnits.MicrogramsPerCubicMetres
    },
    o3: {
        formula: PollutantType.o3,
        unit: TopTriggerUnits.MicrogramsPerCubicMetres
    },
    no2: {
        formula: PollutantType.no2,
        unit: TopTriggerUnits.PartsPerBillion
    },
    so2: {
        formula: PollutantType.so2,
        unit: TopTriggerUnits.PartsPerBillion
    },
    co: {
        formula: PollutantType.co,
        unit: TopTriggerUnits.PartsPerBillion
    }
} as const;

export const HealthAdviceTypes = {
    general: 'general',
    lungAndHeartDisease: 'lungAndHeartDisease',
    children: 'children',
    active: 'active'
} as const;

export interface CommonErrorUIProps {
    isMap?: boolean;
}

export type PollutantKey = typeof pollutantList[number];

export type PollutantsDataType = ReturnType<typeof AirQualityProvider.prototype.getPollutantTypes>